import {
  globalGetService,
  globalPutService,
  globalPostService,
} from '../../../utils/globalApiServices';

export function fetchBrandDetail(brandId, query = {}) {
  return globalGetService(`mno/brands/${brandId}`, query);
}
export function getBrandsDetailApi(brandId, query = {}) {
  fetchBrandDetail(brandId, query).then((response) => {
    const brand = response.data;
    if (response.status >= 200 && response.status < 300) {
      this.setState((prevState) => ({
        ...prevState,
        brandInfo: brand,
        loader: false,
      }));
      this.checkSuspensionStatus();
    }
  });
}

export const updateBulkCampaignStatusApi = async (
  campaignUids,
  status,
  explanation,
  suspensionCategory
) => {
  const body = {
    campaignUid: campaignUids,
    status,
    explanation,
    suspensionCategory,
  };
  const response = await globalPutService(`mno/campaigns/status`, body);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error('Unexpected error');
};

export const findAllIdentityStatuses = async () => {
  const response = await globalGetService('enums/brandIdentityStatus');
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
};

export const getSuspensionCategories = async () => {
  const response = await globalGetService('enums/suspensionCategories');
  if (response?.ok) {
    return response.data;
  }
};

export const getSuspensionCategoryOptions = async () => {
  const categories = await getSuspensionCategories();
  if (categories.length) {
    return categories.map((category) => ({
      label: category.name,
      value: category.id,
    }));
  } else {
    return [];
  }
};

export const getSuspensionRule = async (query = {}) => {
  const response = await globalGetService('mno/suspenisonRule', { ...query });
  if (response && response.status >= 200 && response.status < 300) {
    return response.data;
  }
};

export const getSuspensionPreviewCampaigns = async (query = {}) => {
  try {
    const response = await globalGetService(
      'mno/suspenisonRule/preview/matchedCampaign',
      {
        ...query,
      }
    );
    if (response && response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    throw new Error('Unexpected API error', error);
  }
};

export const getSuspensionPreviewBrands = async (query = {}) => {
  try {
    const response = await globalGetService(
      'mno/suspenisonRule/preview/matchedBrand',
      {
        ...query,
      }
    );
    if (response && response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    throw new Error('Unexpected API error', error);
  }
};

export const createSuspensionRule = async (payload) => {
  const response = await globalPostService(`mno/suspenisonRule`, payload);
  if (response && response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error('Unexpected API error');
};

export const updateSuspensionRule = async (ruleId, payload) => {
  const response = await globalPutService(
    `mno/suspenisonRule/${ruleId}`,
    payload
  );
  if (response && response.status >= 200 && response.status < 300) {
    return response.data;
  }
  throw new Error('Unexpected API error');
};
